import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { VAutocomplete } from 'vuetify/components'
import ScheduleService from '@/Network/Services/ScheduleUnitService'
import { computed, ref, watch } from 'vue'
import { useErrorToast } from '@/composables/useErrorToast'

const LOAD_ERROR_MESSAGE = 'Não foi possível carregar os responsáveis pela escala.'

export default /*#__PURE__*/_defineComponent({
  __name: 'SelectUserSponsor',
  props: {
    modelValue: {},
    schedule: {},
    userSponsorIdErr: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props;



const isLoading = ref(false)



const { notifyError } = useErrorToast()

const scheduleService = new ScheduleService()
const listAdminUsers = ref<{ id: number; name: string }[]>([])

const loadError = ref<string | null>(null)

// Sem estado de erro, a lista vazia se confunde com "não há responsáveis
// cadastrados" — o campo precisa dizer que a carga é que falhou.
const errorMessages = computed(() => props.userSponsorIdErr || loadError.value || undefined)

const fetchAdminUsers = async (scheduleId: number) => {
  try {
    isLoading.value = true
    loadError.value = null
    listAdminUsers.value = await scheduleService.stationCreatingUsers(scheduleId)
  } catch (error) {
    listAdminUsers.value = []
    loadError.value = LOAD_ERROR_MESSAGE
    notifyError(error, LOAD_ERROR_MESSAGE)
  } finally {
    isLoading.value = false
  }
}

watch(
  () => props.schedule,
  (newVal) => {
    if (newVal) {
      fetchAdminUsers(newVal)
    } else {
      listAdminUsers.value = []
      loadError.value = null
      emit('update:modelValue', undefined)
    }
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  const _component_v_list_item = _resolveComponent("v-list-item")!

  return (_openBlock(), _createBlock(_unref(VAutocomplete), {
    label: "Médico Escalado por",
    items: listAdminUsers.value,
    "item-title": "name",
    "item-value": "id",
    "model-value": isLoading.value ? 'Buscando...' : _ctx.modelValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event))),
    placeholder: "Digite para buscar um usuário...",
    class: "w-full",
    color: "primary20",
    clearable: "",
    theme: "light",
    variant: "outlined",
    density: "comfortable",
    loading: isLoading.value,
    "error-messages": errorMessages.value
  }, {
    item: _withCtx(({ props, item }) => [
      _createVNode(_component_v_list_item, _mergeProps(props, {
        title: item.raw.name
      }), null, 16, ["title"])
    ]),
    _: 1
  }, 8, ["items", "model-value", "loading", "error-messages"]))
}
}

})